export enum InvoiceCondition {
  SendingDate = "sending_date",
  OrderItem = "order_item",
  Custom = "custom",
}
